import { useTranslation } from "react-i18next";
import styles from "./BetaBanner.module.css";

// Reusable "this is beta, don't share yet" notice for dark-launched pages.
// Render it only while the feature is still beta (e.g. gated on !FEATURE_PUBLIC); it's meant to
// disappear at launch. Deliberately page chrome — never put this inside a shareable card/PNG.
const BetaBanner = ({ messageKey = "beta.dontShare" }: { messageKey?: string }) => {
  const { t } = useTranslation("pages");
  return (
    <div className={styles.banner} role="note">
      <span className={styles.badge}>BETA</span>
      <span className={styles.text}>{t(messageKey)}</span>
    </div>
  );
};

export default BetaBanner;
